let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1vHyq"), load("koKgZ")]).then(() => parcelRequire('7Fmwh'));